import React from "react";

const ScreenGraph = (props: React.SVGProps<SVGSVGElement>) => {
  const id = Math.round(Math.random() * 100);
  return (
    <svg viewBox="0 0 192.183 192" {...props}>
      <defs>
        <linearGradient
          id={`screen-graph-gradient-a-${id}`}
          x1="0.5"
          y1="1"
          x2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#d3e6f5" />
          <stop offset="1" stopColor="#f0f7fc" />
        </linearGradient>
        <linearGradient
          id={`screen-graph-gradient-b-${id}`}
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#54a5ff" />
          <stop offset="1" stopColor="#8ad3fe" />
        </linearGradient>
        <linearGradient
          id={`screen-graph-gradient-c-${id}`}
          x1="0"
          y1="0.5"
          x2="1"
          y2="0.5"
          href="#a"
        />

        <clipPath id={`screen-graph-gradient-e-${id}`}>
          <path
            fill={`url(#screen-graph-gradient-a-${id})`}
            d="M257.988,116.692v96h-192v-96A20.588,20.588,0,0,1,86.559,96.121H237.417A20.588,20.588,0,0,1,257.988,116.692Z"
          />
        </clipPath>
        <linearGradient
          id={`screen-graph-gradient-f-${id}`}
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#fe9661" />
          <stop offset="1" stopColor="#ffb369" />
        </linearGradient>
      </defs>

      <g transform="translate(0 0)">
        <path
          fill={`url(#screen-graph-gradient-b-${id})`}
          d="M257.988,130.121v13.714a20.588,20.588,0,0,1-20.571,20.571H86.559a20.588,20.588,0,0,1-20.571-20.571V130.121Z"
          transform="translate(-65.988 -13.55)"
        />
        <g transform="translate(-65.988 -96.121)">
          <path
            fill="#4795ea"
            d="M140.127,140.121H97.809L83.7,181.264h70.53Z"
            transform="translate(43.021 106.858)"
          />
          <g transform="translate(117.417 281.264)">
            <path
              fill="#0668cb"
              d="M166.7,156.978H84.417a3.429,3.429,0,0,1,0-6.857H166.7a3.429,3.429,0,0,1,0,6.857Z"
              transform="translate(-80.988 -150.121)"
            />
          </g>
        </g>
        <g transform="translate(89.143 130.286)">
          <path
            fill={`url(#screen-graph-gradient-c-${id})`}
            d="M102.274,140.978H95.417a3.429,3.429,0,1,1,0-6.857h6.857a3.429,3.429,0,0,1,0,6.857Z"
            transform="translate(-91.988 -134.121)"
          />
        </g>
        <path
          fill={`url(#screen-graph-gradient-a-${id})`}
          d="M257.988,116.692v96h-192v-96A20.588,20.588,0,0,1,86.559,96.121H237.417A20.588,20.588,0,0,1,257.988,116.692Z"
          transform="translate(-65.988 -96.121)"
        />
        <g clipPath={`url(#screen-graph-gradient-e-${id})`} transform="translate(-65.988 -96.121)">
          <g transform="translate(5.988 89.264)">
            <g transform="translate(15.761)">
              <path
                fill="#0053aa"
                d="M388.469,166.25H173.985c-18.215,0-33-3.6-33-8.064s14.783-8.064,33-8.064H388.469c18.248,0,33,3.613,33,8.064S406.717,166.25,388.469,166.25Z"
                transform="translate(-140.988 -150.121)"
              />
            </g>
          </g>
        </g>
        <path
          fill="none"
          stroke="#eb7f58"
          strokeWidth="3px"
          strokeDasharray="5 8"
          opacity="0.75"
          d="M13094.577-2289.195l45.769,31.372,40.776-52.417,51.685,38.75"
          transform="translate(-13068 2349)"
        />
        <circle
          fill={`url(#screen-graph-gradient-f-${id})`}
          cx="6.857"
          cy="6.857"
          r="6.857"
          transform="translate(20.572 53.001)"
        />
        <circle
          fill={`url(#screen-graph-gradient-f-${id})`}
          cx="6.857"
          cy="6.857"
          r="6.857"
          transform="translate(65.144 80.858)"
        />
        <circle
          fill={`url(#screen-graph-gradient-f-${id})`}
          cx="6.857"
          cy="6.857"
          r="6.857"
          transform="translate(106.286 32.43)"
        />
        <circle
          fill={`url(#screen-graph-gradient-f-${id})`}
          cx="6.857"
          cy="6.857"
          r="6.857"
          transform="translate(157.715 70.144)"
        />
      </g>
    </svg>
  );
};

export default ScreenGraph;
